import { spacing } from '@120wateraudit/envirio-components'
import * as React from 'react'
import { Form } from 'semantic-ui-react'
import styled from 'styled-components'
import { ReactComponent as ZoomSplitIcon } from 'src/assets/images/zoom-split.svg'

interface Props {
  pluralEntityName: string
  entityName: string
  showSearchTerms?: boolean
}

export const NoResults = ({
  pluralEntityName,
  entityName,
  showSearchTerms = true
}: Props) => (
  <Wrapper>
    <NoResultsFound>
      <ImageWrapper>
        <ZoomSplitIcon
          style={{ margin: 'auto', width: '8rem', height: '8rem' }}
        />
      </ImageWrapper>
      <HeaderWrapper>
        <HeaderText>No {pluralEntityName} found!</HeaderText>
      </HeaderWrapper>
      <Form>
        <TextWrapper>
          <NotFoundText>
            It looks like there aren't any {pluralEntityName} to show.
          </NotFoundText>
        </TextWrapper>
        {showSearchTerms ? (
          <TextWrapper>
            <SubText>Try another search term, add a new {entityName}.</SubText>
          </TextWrapper>
        ) : null}
      </Form>
    </NoResultsFound>
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const NoResultsFound = styled.div`
  max-height: 27.167rem;
  max-width: 48.667rem;
  background: ${props => props.theme.colors.white};
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0.66rem;
  padding: ${spacing.big};
  margin: ${spacing.tiny};
`
const ImageWrapper = styled.div`
  display: flex;
`
const HeaderWrapper = styled.div`
  display: flex;
  margin-top: ${spacing.small};
`
const HeaderText = styled.h5`
  margin: auto;
  text-align: center;
  padding-bottom: ${spacing.tiny};
`
const TextWrapper = styled.div`
  display: flex;
  margin: auto;
`
const NotFoundText = styled.span`
  margin: auto;
  font-weight: normal;
  font-size: 1.167rem;
  text-align: center;
`
const SubText = styled.span`
  margin: auto;
  font-weight: normal;
  font-size: 1.167rem;
  text-align: center;
  margin-top: 0.667rem;
`
